import axios from '../axios'
import qs from "qs";

function service(endpoint) {

    function download(id, data = {}) {
        return axios.get(`${endpoint}/${id}/download`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        download
    }
}

export default service
